/**
 * ContactMap
 * @class
 * @constructor
 * @public
 */
class ContactMap {
  /**
   * Constructor
   * @param {string} name The container to handle
   * @returns {object} options The options
   * @returns {class}
   */
  constructor() {
    this.components = document.querySelectorAll('[data-contactmap]');

    // Engage engines
    if (this.components) {
      this.components.forEach((component) => {
        this.init(component);
      });
    }
  }

  /**
   * Initialize the component
   * @returns {void}
   */
  init(component) {
    this.scroller = component.querySelector('[data-contactmap-scroller]');
    this.paths = component.querySelectorAll('[data-contactmap-path]');
    this.lists = component.querySelectorAll('[data-contactmap-list]');

    this.paths.forEach((path) => {
      path.addEventListener('click', () => {
        const stateName = path.getAttribute('data-contactmap-path');
        this.lists.forEach((list) => {
          list.classList.toggle('is-visible', list.getAttribute('data-contactmap-list') === stateName);
        });
        this.paths.forEach((state) => {
          state.classList.remove('is-active');
        });
        path.classList.add('is-active');
        this.scroller.scrollTop = 0;
      });
    });
  }

}

module.exports = ContactMap;
